import { z } from "zod";

// Schema genérico para secciones con radio
const radioSchema = z.enum(["si", "no"], {
  required_error: "Debe seleccionar una opción",
});

export const miembroJuntaSchema = z.object({
  tipoDocumento: z
    .string({
      required_error: "Seleccione tipo de documento",
    })
    .min(1, "Seleccione tipo de documento")
    .nonempty("Campo obligatorio"),
  numeroDocumento: z
    .string({
      required_error: "Ingrese número de documento",
    })
    .min(1, "Ingrese número de documento")
    .nonempty("Campo obligatorio"),
  nombreCompleto: z
    .string({ required_error: "Ingrese nombre completo o razón social" })
    .min(1, "Ingrese nombre completo o razón social")
    .nonempty("Campo obligatorio"),
  cargo: z
    .string({ required_error: "Ingrese el cargo" })
    .min(1, "Ingrese el cargo")
    .nonempty("Campo obligatorio"),
  fechaInicio: z
    .string({ required_error: "Ingrese la fecha inicio" })
    .min(1, "Ingrese la fecha inicio")
    .nonempty("Campo obligatorio"),
  fechaFin: z
    .string({ required_error: "Ingrese la fecha fin" })
    .min(1, "Ingrese la fecha fin")
    .nonempty("Campo obligatorio"),
  parentesco: z
    .string({ required_error: "Ingrese el parentesco" })
    .min(1, "Ingrese el parentesco"),
});

// Sección con detalle condicional (solo PEP)
const pepSchema = z
  .object({
    respuesta: radioSchema,
    miembros: z.array(miembroJuntaSchema).optional(),
  })
  .superRefine((data, ctx) => {
    if (
      data.respuesta === "si" &&
      (!data.miembros || data.miembros.length === 0)
    ) {
      ctx.addIssue({
        path: ["miembros"],
        code: "custom",
        message: "Ingresar información del PEP",
      });
    }
  });

const conflictoInteresSchema = z
  .object({
    respuesta: radioSchema,
    detalle: z.string().min(1, "Debe ingresar el detalle").optional(),
  })
  .refine(
    (data) => {
      console.log("data.respuesta :>> ", data.respuesta);
      if (data.respuesta === "si") {
        return !!data.detalle && data.detalle.trim().length > 0;
      }
      return true;
    },
    {
      message: "Debe ingresar el detalle si la respuesta es 'sí'",
      path: ["detalle"],
    }
  );

export const AutorizacionesSchema = z.object({
  pep: pepSchema,
  origenFondos: radioSchema.superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: "invalid_type",
        expected: "string",
        received: "undefined",
        message: "Debe seleccionar una opción",
        path: ["origenFondos"],
      });
    }

    if (data === "no") {
      ctx.addIssue({
        code: "custom",
        message:
          "En caso de elegir 'No', no será posible finalizar el formulario.",
      });
    }
  }),
  datosPersonales: radioSchema.superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: "invalid_type",
        expected: "string",
        received: "undefined",
        message: "Debe seleccionar una opción",
        path: ["datosPersonales"],
      });
    }
    if (data === "no") {
      ctx.addIssue({
        code: "custom",
        message:
          "En caso de elegir No, no será posible finalizar el formulario.",
      });
    }
  }),
  centralesRiesgo: radioSchema,
  conflictoInteres: conflictoInteresSchema,
  gobiernoCorporativo: radioSchema.superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: "invalid_type",
        expected: "string",
        received: "undefined",
        message: "Debe seleccionar una opción",
        path: ["gobiernoCorporativo"],
      });
    }
    if (data === "no") {
      ctx.addIssue({
        code: "custom",
        message:
          "En caso de elegir No, no será posible finalizar el formulario.",
      });
    }
  }),
  // 👇 Implicaciones es solo informativa, no se valida
  implicaciones: z.undefined().optional(),
});

// Tipo inferido para usar en RHF
export type AutorizacionesForm = z.infer<typeof AutorizacionesSchema>;
